import { BaseIcon, BaseIconProps } from "./BaseIcon";

export function EyeIcon(props: BaseIconProps) {
  return (
    <BaseIcon {...props} viewBox="0 0 18 14">
      <path
        fill="currentColor"
        d="M9 0c5.63 0 8.2 4.87 8.87 6.36a1.58 1.58 0 0 1 0 1.28C17.2 9.13 14.63 14 9 14 3.37 14 .8 9.13.13 7.64a1.58 1.58 0 0 1 0-1.28C.8 4.87 3.37 0 9 0Zm1.72 2.69a4.35 4.35 0 0 0-4.9 1.01 4.72 4.72 0 0 0-.98 5.09c.34.85.92 1.58 1.66 2.09a4.39 4.39 0 0 0 5.68-.58 4.76 4.76 0 0 0-1.46-7.61ZM9 3.89c1.66 0 3 1.4 3 3.11a3.06 3.06 0 0 1-3 3.11c-1.66 0-3-1.4-3-3.11a3.06 3.06 0 0 1 3-3.11Z"
      />
    </BaseIcon>
  );
}
